import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle, faToggleOn } from '@fortawesome/pro-solid-svg-icons'

import { Box, Button, Text } from '@domain-group/suit-theme'

import useProviderPackage from '@hooks/useProviderPackage'
import type { UseProviderPackagePayload } from '@hooks/useProviderPackage'

import handleCallbackAction from '@functions/handleCallbackAction'

import type { ProviderPackageModel } from '@models/types'

const confirmEnablePackage = (
  unarchiveProviderPackage: UseProviderPackagePayload['callbacks']['unarchiveProviderPackage'],
) => {
  const unarchivePackagePayload = {
    callbacks: {
      action: unarchiveProviderPackage,
    },
    toastText: 'Package Enabled',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, enable it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Enable Package?',
  }).then(({ value }) => {
    if (value){
      // @ts-expect-error TS2345
      handleCallbackAction(unarchivePackagePayload)
    }
  })
}

type ProviderPackageArchivedBannerProps = {
  providerPackage: ProviderPackageModel,
}

const ProviderPackageArchivedBanner = (props: ProviderPackageArchivedBannerProps) => {
  const { providerPackage } = props

  const {
    callbacks: { unarchiveProviderPackage },
    providerPackage: { hidden },
  } = useProviderPackage(providerPackage)

  if (!hidden) return null

  return (
    <Box alignItems="center" flexDirection={['column', 'row']} marginBottom="large" padding="large" variant="white">
      <Box>
        <Box
          backgroundColor="orange"
          borderRadius={5}
          color="white"
          fontSize="large"
          padding="large"
          width="fit-content"
        >
          <FontAwesomeIcon icon={faExclamationTriangle} />
        </Box>

        <Box flexDirection="column" justifyContent="center" marginLeft="large">
          <Text fontSize="small" marginBottom="small">Package is Archived</Text>

          <Text fontSize="small" color="bodyFontLightColor" marginTop="small">
            This Package has been archived.
          </Text>
        </Box>
      </Box>

      <Button
        buttonStyle="secondaryUtility"
        height="fit-content"
        icon={<FontAwesomeIcon icon={faToggleOn} />}
        marginTop={['large', 0]}
        onClick={() => confirmEnablePackage(unarchiveProviderPackage)}
        size="medium"
        width={['100%', 'fit-content']}
      >
        Enable Package
      </Button>
    </Box>
  )
}

export default ProviderPackageArchivedBanner
